/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 * File Path: apps/web/src/routes/+layout.ts
 */

export const ssr = true;
export const prerender = false;
export const csr = true;
